export const queryKeyBuilder = {
  currentUser: () => ['currentUser'] as const,
  giftCardsStatuses: () => ['giftCardsStatuses'] as const,
  giftCardsProducts: () => ['giftCardsProducts'] as const,
  giftCardsToShow: (queryParams: unknown) => ['giftCards', queryParams] as const,
  giftCardsToExport: (queryParams: unknown) => ['exportedGiftCards', queryParams] as const,
  dgcOrdersToShow: (queryParams: unknown) => ['dgcOrders', queryParams] as const,
  dgcOrderDetail: (uuid: string) => ['dgcOrderDetail', uuid] as const,
};
